<template>
  <div>
    <div>
      <h4 class="font-bold">
        We do not recognize this address.
      </h4>
      <p class="mt-2">
        Please verify it is correct before continuing.
        If your address is incorrect, you can adjust by selecting Edit.
      </p>
    </div>
    <div class="c-hairline my-5" />
    <div>
      <p>New Address</p>
      <div class="mt-2 text-blue-200 uppercase">
        {{ streetAddress }}<br>
        {{ city }}, {{ state }} {{ zipCode }}<br v-if="urbanizationName">
        {{ urbanizationName }}
      </div>
      <button
        id="new-constr-edit"
        class="c-btn--secondary mt-5 w-full lg:w-auto"
        @click="$emit('reset')"
      >
        Edit
      </button>
    </div>
    <div class="c-hairline my-5" />
    <p>
      If the new address above is correct, was it built in the last 6 months?
    </p>
    <div class="flex flex-row flex-wrap lg:flex-nowrap mt-5">
      <button
        id="new-constr-yes"
        class="c-btn--secondary w-full lg:w-auto lg:mr-3"
        @click="$emit('override', true)"
      >
        Yes
      </button>
      <button
        id="new-constr-no"
        class="c-btn w-full lg:w-auto mt-6 lg:mt-0"
        @click="$emit('override', false)"
      >
        No
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ModalNewConstruction',
  props: {
    streetAddress: {
      type: String,
      default: '',
    },
    city: {
      type: String,
      default: '',
    },
    state: {
      type: String,
      default: '',
    },
    zipCode: {
      type: String,
      default: '',
    },
    urbanizationName: {
      type: String,
      default: '',
    },
  },
};
</script>
